
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { Button,} from "react-bootstrap";
import { Modal } from "react-bootstrap";

const EditProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const [oldImages, setOldImages] = useState([]); 
const [newImages, setNewImages] = useState([]);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const [showNewCategory, setShowNewCategory] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [selectedTax, setSelectedTax] = useState(null);
const [showImageModal, setShowImageModal] = useState(false);
 const [preview, setPreview] = useState([]);

  const [form, setForm] = useState({
    product_name: "",
    brand: "",
    price: "",
    mrp: "",
    sell_price: "",
    stock: "",
    barcode: "",
    tax: "",
    discount: "",
    discount_value: "",
    description: "",
     img: [],
  });


  
  const categoryOptions = [
    ...categories.map(cat => ({ label: cat, value: cat })),
    { label: "➕ Add new category", value: "__add_new__" }
  ];

  const taxOptions = [
    { label: "None", value: "" },
    { label: "0 %", value: "0 %" },
    { label: "0.25 %", value: "0.25 %" },
    { label: "3 %", value: "3 %" },
    { label: "5 %", value: "5 %" },
    { label: "12 %", value: "12 %" },
    { label: "18 %", value: "18 %" },
    { label: "28 %", value: "28 %" }
  ];

  const discountOptions = [
    { value: "amount", label: " Amount" },
    { value: "percent", label: "Percentage" },

  ];


  /* ================= FETCH PRODUCT ================= */
  useEffect(() => {
    if (!id) return;

    const fetchProduct = async () => {
      try {
        const res = await axios.get(
          "https://api.bigfresh.in/fecth-product"
        );

        const list = Array.isArray(res.data) ? res.data : [];
        const uniqueCategories = [
      ...new Set(
        list
          .map(p => p.category)
          .filter(Boolean)
      )
    ];

    setCategories(uniqueCategories);

    
        const product = list.find(
          (p) => String(p.id) === String(id)
        );

        if (!product) {
          toast.error("Product not found", { position: "top-center" });
          navigate("/inventory");
          return;
        }


        

        setForm({
          id:product.id,
          product_name: product.product_name || "",
          brand: product.brand || "",
          price: product.price || "",
          mrp: product.mrp || "",
          sell_price: product.sell_price || "",
          stock: product.stock || "",
          barcode: product.barcode || "",
          tax: product.tax || "",
          discount: product.discount || "",
          discount_value: product.discount_value || "",
          description: product.description || "",
         category:product.category || "",
        });

          setOldImages(product.img ? product.img.split(",") : []);
      } catch (error) {
        toast.error("Failed to fetch product", { position: "top-center" });
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id, navigate]);



   useEffect(() => {
    handleDeleteImage();
   })

  /* ================= CHANGE ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= UPDATE ================= */

  const handleUpdate = async (e) => {
  e.preventDefault();
  setUpdating(true);

  try {
    const formData = new FormData();

    // 🔹 append normal form fields
    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    // 🔹 append old images (stringified array)
    formData.append("oldImages", JSON.stringify(oldImages));

    // 🔹 append new images (files)
    newImages.forEach((file) => {
      formData.append("img", file);
    });

    await axios.put(
      `https://api.bigfresh.in/update-product/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    toast.success("Product updated successfully!", { position: "top-center" });
    setTimeout(() => navigate("/inventory"), 1500);

  } catch (error) {
    toast.error("Product update failed", { position: "top-center" });
    console.error(error);
  } finally {
    setUpdating(false);
  }
};



const handleDeleteImage = async (src, index, productId) => {
  try {
    if (!productId) {
      console.error("Product ID is missing!");
      return;
    }

    const filename = src.split("/").pop();
 
    const { data } = await axios.delete(
      "https://api.bigfresh.in/delete-product-image",
      { data: { filename, id: productId } }
    );

    if (data.success) {
      setOldImages(data.images || []);

      // setPreview(prev => prev.filter((_, i) => i !== index));
       toast.success(data.message || "Image deleted successfully!", { position: "top-center" });

       console.log("Delete API response:", data);

    } else {
      console.error("API returned failure:", data);
      toast.error("Failed to delete image", { position: "top-center" });
    }
  } catch (error) {
    console.error("Error deleting image:", error.response || error);
   toast.error("Failed to delete image", { position: "top-center" });

  }
};


  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  return (
    <div className="container mt-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold">Inventory</h3>
        <button
          className="btn btn-outline-danger"
          onClick={() => navigate("/inventory")}
        >
          Cancel
        </button>
      </div>

      {/* CARD */}
      <div className="card shadow-sm">
        <div className="card-header bg-success text-white fw-bold">
         Edit Product
        </div>

        <div className="card-body">
       <form onSubmit={handleUpdate} className="row g-3">

  {/* LEFT COLUMN */}
  <div className="col-md-6 d-flex flex-column gap-3">
    {/* Product Name */}
    <div>
      <label className="form-label">Product Name</label>
      <input
        className="form-control"
        name="product_name"
        value={form.product_name}
        onChange={handleChange}
        required
      />
    </div>

    {/* Brand */}
    <div>
      <label className="form-label">Brand</label>
      <input
        className="form-control"
        name="brand"
        value={form.brand}
        onChange={handleChange}
      />
    </div>

    {/* Price */}
    <div>
      <label className="form-label">Price</label>
      <input
        className="form-control"
        name="price"
        value={form.price}
        onChange={handleChange}
      />
    </div>

    {/* MRP */}
    <div>
      <label className="form-label">MRP</label>
      <input
        className="form-control"
        name="mrp"
        value={form.mrp}
        onChange={handleChange}
      />
    </div>

    {/* Sell Price */}
    <div>
      <label className="form-label">Sell Price</label>
      <input
        className="form-control"
        name="sell_price"
        value={form.sell_price}
        onChange={handleChange}
      />
    </div>

    {/* Description */}
    <div>
      <label className="form-label">Description</label>
      <textarea
        className="form-control"
        rows="5"
        name="description"
        value={form.description}
        onChange={handleChange}
      />
    </div>
  </div>

  {/* RIGHT COLUMN */}
  <div className="col-md-6 d-flex flex-column gap-3">
    {/* Stock */}
    <div>
      <label className="form-label">Stock</label>
      <input
        className="form-control"
        name="stock"
        value={form.stock}
        onChange={handleChange}
      />
    </div>

    {/* Barcode */}
    <div>
      <label className="form-label">Barcode</label>
      <input
        className="form-control"
        name="barcode"
        value={form.barcode}
        onChange={handleChange}
      />
    </div>



<div >
  <label className="form-label">Category</label>

  <Select
    options={[
      ...categories.map(cat => ({ label: cat, value: cat })),
      { label: "➕ Add New Category", value: "__add_new__" }
    ]}
    value={
      form.category
        ? { label: form.category, value: form.category }
        : null
    }
    onChange={(option) => {
      if (!option) {
        setForm(prev => ({ ...prev, category: "" }));
        return;
      }

      if (option.value === "__add_new__") {
        setNewCategory("");
        setShowNewCategory(true);
        return;
      }

      setForm(prev => ({ ...prev, category: option.value }));
    }}
  />

  {showNewCategory && (
    <div
      className="position-fixed top-50 start-50 translate-middle p-4 bg-white border rounded shadow"
      style={{ width: "350px", zIndex: 1050 }}
    >
      <div className="mb-3">
        <label htmlFor="newCategory" className="form-label">
          New Category
        </label>
        <input
          id="newCategory"
          type="text"
          className="form-control"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          autoFocus
          placeholder="Enter new category"
        />
      </div>

      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="secondary"
          onClick={() => {
            setShowNewCategory(false);
            setNewCategory("");
          }}
        >
          Cancel
        </Button>

        <Button
          variant="success"
          onClick={() => {
            if (!newCategory.trim()) return;
              setCategories(prev => [...prev, newCategory]);

    // Select the new category
    setForm(prev => ({ ...prev, category: newCategory }));


            setNewCategory("");
            setShowNewCategory(false);
          }}
        >
          Save
        </Button>
      </div>
    </div>
  )}
</div>


<div className="mb-3">
  <label className="form-label">Tax</label>
  <Select
    options={taxOptions}
    value={taxOptions.find(option => option.value === form.tax)} 
    onChange={(selectedOption) => {
      setForm(prev => ({ ...prev, tax: selectedOption.value }));
    }}
    isClearable
    placeholder="Select Tax"
  />
</div>

    <div>
      <label className="form-label">Discount</label>
      <Select
        placeholder="Select Discount"
        options={discountOptions}
        value={discountOptions.find(opt => opt.value === form.discount)}
        onChange={(option) =>
          setForm(prev => ({ ...prev, discount: option.value }))
        }
      />
    </div>

    <div>
      <label className="form-label">Discount Value</label>
      <input
        type="number"
        className="form-control"
        name="discount_value"
        value={form.discount_value}
        onChange={handleChange}
      />
    </div>


    <div  className="mb-3 d-flex align-items-end gap-2">

        <div className="flex-grow-1">
         
      <label className="form-label">Upload Images</label>
      <input
        className="form-control"
        type="file"
        multiple
        accept="image/*"
        onChange={(e) => setNewImages([...e.target.files])}
      />
        </div>

          <div>
    <Button
      variant="primary"
      onClick={() => setShowImageModal(true)}
      style={{ marginBottom: "0.25rem" }}
    >
      Preview 
    </Button>
  </div>

    </div>

  </div>


<Modal
  show={showImageModal}
  onHide={() => setShowImageModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Product Images</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <div className="d-flex flex-wrap gap-2">

      {oldImages.map((img, index) => (
        <div key={`old-${index}`} className="position-relative">
          <img
            src={`https://api.bigfresh.in/uploads/${img}`}
            alt=""
            className="img-thumbnail"
            style={{ width: "200px", height: "200px", objectFit: "cover" }}
          />
          <button
            type="button"
            className="btn btn-sm btn-danger position-absolute top-0 end-0"
            onClick={() => handleDeleteImage(img, index, form.id)}
          >
            &times;
          </button>
        </div>
      ))}


      {newImages.map((file, index) => (
        <div key={`new-${index}`} className="position-relative">
          <img
            src={URL.createObjectURL(file)}
            alt=""
            className="img-thumbnail"
            style={{ width: "120px", height: "120px", objectFit: "cover" }}
          />
          <button
            type="button"
            className="btn btn-sm btn-danger position-absolute top-0 end-0"
            onClick={() =>
              setNewImages(prev => prev.filter((_, i) => i !== index))
            }
          >
            &times;
          </button>
        </div>
      ))}

    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowImageModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>


  {/* Submit Button */}
  <div className="col-12 d-flex justify-content-start">
    <button type="submit" className="btn btn-success">
      {updating ? "Updating..." : "Update"}
    </button>
  </div>
</form>

        </div>
      </div>
            <ToastContainer />
    </div>
  );
};

export default EditProduct;
